import { ResponseStoreFrontSmeLoan } from '@/src/interfaces/data-contracts';
import ImageWithFallback from '../../ui/image/image-with-fallback';
import Heading from '../../ui/heading';
import { Button } from '../../ui/button/button';
import LinkLikeButton from '../link-like-button';
import { ArrowUpRight } from '../../ui/icons/icons';

type Props = {
  item: ResponseStoreFrontSmeLoan;
};

export const CustomerStatusModal: React.FC<Props> = ({ item }) => {
  return (
    <>
      <div className="flex flex-col gap-8 md:hidden">
        <div className="flex flex-col items-center gap-4">
          <figure className="relative h-[72px] w-[150px] rounded-lg border border-background200">
            <ImageWithFallback className="px-3" src={item.bank?.logoPath} alt={item.name} title={item.name} fill />
          </figure>
          <p className="text-lg font-medium text-black900">{item.qrPopUpTitle}</p>
        </div>
        <div className="flex w-full flex-col justify-center gap-3 md:flex-row">
          {item.recourseLink && (
            <LinkLikeButton
              target={item.target}
              external
              className="w-full text-base"
              text={item.bank?.name + ' Müşterisiyim'}
              href={item.recourseLink}
            ></LinkLikeButton>
          )}
          {item.qrPopUpLink && (
            <LinkLikeButton
              target={item.target}
              external
              className="w-full px-4 py-3 text-base"
              text="Henüz Müşteri Değilim"
              href={item.qrPopUpLink}
            ></LinkLikeButton>
          )}
        </div>
      </div>

      <section className="hidden flex-col gap-8 md:flex">
        <section className="flex flex-col items-center gap-4">
          <figure className="relative h-[72px] w-[150px] rounded-lg border border-background200">
            <ImageWithFallback className="px-3" src={item.bank?.logoPath} alt={item.name} title={item.name} fill />
          </figure>
          {item.qrPopUpTitle && (
            <Heading tagType={'h3'} cls="md:text-xl text-base text-black900 text-center" bolded>
              {item.qrPopUpTitle}
            </Heading>
          )}
        </section>

        <section className="flex flex-col gap-8">
          {item.qrPopUpDescription && (
            <div className="border-bg200 flex flex-col gap-6 rounded-xl border p-5 md:flex-row md:items-center md:justify-between md:px-5 md:py-12">
              <div className="flex-1 basis-0 flex-col gap-3">
                <Heading tagType={'p'} cls="md:text-lg text-base text-gray1000 font-semibold">
                  Evet, {item.bank?.name} Müşterisiyim
                </Heading>
                <div
                  className="text-sm text-black700"
                  dangerouslySetInnerHTML={{ __html: item.qrPopUpDescription ?? '' }}
                />
              </div>

              {item.qrPopUpLink && (
                <Button
                  text={item.qrPopUpButtonText ?? 'Hemen Başvur'}
                  className="h-[48px] w-[161px] rounded-lg text-sm font-bold md:w-[177px] md:text-base"
                  href={item.qrPopUpLink}
                >
                  <ArrowUpRight width={28} height={28} />
                </Button>
              )}
            </div>
          )}

          {item && (
            <div className="border-bg200 flex flex-col gap-6 rounded-xl border bg-gray100 p-5 md:flex-row md:items-center md:justify-between">
              <div className="flex flex-col gap-3">
                <Heading tagType={'p'} cls="md:text-lg text-base text-gray1000 font-semibold">
                  Henüz Müşteri Değilim
                </Heading>
                <div className="text-sm text-black700" dangerouslySetInnerHTML={{ __html: item.qrPopUpText ?? '' }} />
              </div>

              <section className="bg-[url('/assets/sme/QR-Frame.png')] bg-cover bg-center bg-no-repeat bg-origin-border">
                <figure className="relative flex items-center justify-center md:h-[126px] md:w-[126px]">
                  <ImageWithFallback
                    src={item.qrCoverImage}
                    alt={item.qrPopUpTitle}
                    title={item.qrPopUpTitle}
                    width={110}
                    height={110}
                  />
                </figure>
              </section>
            </div>
          )}
        </section>
      </section>
    </>
  );
};
